<div class="chat-container">

    <app-conversations *ngIf="!(hideConversations$ |async)" id="conversations"></app-conversations>

    <app-dialog id="dialog"></app-dialog>


</div>
